import { useCrumbs } from "@/components/layout/CrumbsContext";
import { GuideView } from "@/components/plan-audit/GuideView";

export function GuidePage() {
  useCrumbs([{ label: "Standard" }, { label: "Solution Plan Guide" }]);
  return (
    <>
      <div className="pa-page-head">
        <div>
          <h1>Solution Plan Guide</h1>
          <p>
            The standard every run scores against. Sections here are what the scorecard quotes back
            under “What the Guide asks for”.
          </p>
        </div>
      </div>
      <GuideView />
    </>
  );
}
